import dynamic from "next/dynamic";
import {useStores} from "../stores/useStores";
import {getQueries} from "../utils/SchoolBlocksUtilities";
import styles from "./styles/ContentItemPage.module.scss";

export const enum IContentView {
    ACCORDION= "accordion",
    NEWS = "news",
}

const pages = {
    [IContentView.ACCORDION]: dynamic(() => import("./AccordionItemPage"), {loading: () => <></>}),
    [IContentView.NEWS]: dynamic(() => import("./NewsItemPage"), {loading: () => <></>}),
}

export default function ContentPage() {
    const {interfaceStore} = useStores();

    const queries = getQueries(interfaceStore.currentFullUrl);

    if (!queries.type || !pages[queries.type]) {
        return <div className={styles.container}>
            <div className={styles.loadingIndicator}>
                Error: content item type supplied in the URL is invalid.
            </div>
        </div>
    }

    const ContentComponent = pages[queries.type];

    return <ContentComponent/>
}
